import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import StatsBar from "./sections/StatsBar";
import BenchmarkProof from "./sections/BenchmarkProof";
import ProductsOverview from "./sections/ProductsOverview";
import TrainingStory from "./sections/TrainingStory";
import OpenSourceResources from "./sections/OpenSourceResources";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <StatsBar />
      <BenchmarkProof />
      <ProductsOverview />
      <TrainingStory />
      <OpenSourceResources />
      <Footer />
    </div>;
}